import React, { useState } from 'react';
import PropTypes from 'prop-types';
import userEventService from '../../services/user-event-service';
import './accordion.scss';

const Accordion = ({ sections }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleTabClick = (index) => {
    setActiveIndex(index);
    
    // Track accordion section view
    const sectionTitle = sections[index]?.title;
    if (sectionTitle) {
      const sectionKey = sectionTitle.toLowerCase().replace(/\s+/g, '_');
      userEventService.trackEvent({
        eventCategory: 'Admin Capabilities',
        eventAction: `admin_section_${sectionKey}_viewed`,
        eventLabel: 'admin_accordion_navigation',
      });
    }
  };

  return (
    <div className="admin-manage-deal-tabs">
      <div className="admin-manage-deal-tab-headers">
        {sections.map((section, index) => (
          <button
            key={index}
            className={`admin-manage-deal-tab-button ${activeIndex === index ? 'active' : ''}`}
            onClick={() => handleTabClick(index)}
            data-text={section.title}
          >
            {section.title}
          </button>
        ))}
      </div>
      
      <div className="admin-manage-deal-tab-content">
        {sections[activeIndex]?.content}
      </div>
    </div>
  );
};

Accordion.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
    })
  ).isRequired,
};

export default Accordion;
